import { useCallback, useEffect, useState } from 'react'
import { useI18n } from '../../i18n'
import { useAuth } from '../AuthProvider'
import { API_ENDPOINTS } from '../../config/api'
import { formatRelativeTime } from '../../utils/operationalUx'
import styles from '@/styles/components/layout/HomeDashboardHeaderActions.module.scss'

/**
 * Shown under the Security Dashboard title — when platform executive data was last refreshed.
 */
export function HomeDataRefreshedMeta() {
  const { t } = useI18n()
  const { token } = useAuth()
  const [refreshedAt, setRefreshedAt] = useState<string | null>(null)

  const refresh = useCallback(async () => {
    if (!token) {
      setRefreshedAt(null)
      return
    }
    try {
      const res = await fetch(`${API_ENDPOINTS.GRC_EXECUTIVE_SUMMARY}?includeDiagnostics=true`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      if (!res.ok) return
      setRefreshedAt(new Date().toISOString())
    } catch {
      /* keep previous timestamp */
    }
  }, [token])

  useEffect(() => {
    void refresh()
  }, [refresh])

  useEffect(() => {
    const onRefresh = () => {
      void refresh()
    }
    window.addEventListener('compliance-updated', onRefresh)
    return () => window.removeEventListener('compliance-updated', onRefresh)
  }, [refresh])

  const label = t('home.dataRefreshed', 'Data refreshed')
  const value = refreshedAt ? formatRelativeTime(refreshedAt) : '—'

  return (
    <p className={styles.lastScan}>
      {label}: <span className={styles.lastScanValue}>{value}</span>
    </p>
  )
}
